
export const SHOW = 'SHOW LOADING';
export const HIDE = 'HIDE LOADING';
export const RESET = 'RESET LOADING';

const defaultState = {
  preloader: {
    loading: 0,
    blocking: false,
  },
};

export function showLoading(blocking = false) {
  return {
    type: SHOW,
    blocking,
  };
}

export function hideLoading() {
  return {
    type: HIDE,
  };
}

export function resetLoading() {
  return {
    type: RESET,
  };
}

export function preloader(state = defaultState.preloader, action = {}) {
  switch (action.type) {
    case SHOW:
      return Object.assign({}, state, {
        loading: state.loading + 1,
        blocking: action.blocking,
      });

    case HIDE:
    case RESET:
      return Object.assign({}, state, {
        loading: 0,
        blocking: false,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/preloader.js